import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type BIInsight } from '../../api/analytics';

export function InsightsPage() {
  const [insights, setInsights] = useState<BIInsight[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void analyticsApi.biInsights().then((r) => setInsights(r.insights ?? [])).catch((e) => setError(String(e)));
  }, []);

  const severityColor = (s: string) => {
    if (s === 'critical') return 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300';
    if (s === 'warning') return 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300';
    return 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300';
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">AI Insights</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-3">
        {insights.map((i) => (
          <div key={i.id} className="rounded-xl border p-4 dark:border-slate-700">
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-medium">{i.title}</p>
                <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{i.description}</p>
              </div>
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${severityColor(i.severity)}`}>{i.severity}</span>
            </div>
            <p className="mt-2 text-xs text-slate-500">{i.domain} · {i.type} · {(i.confidence * 100).toFixed(0)}% confidence</p>
          </div>
        ))}
      </div>
    </div>
  );
}
